import { render, staticRenderFns } from "./solutionMobile.vue?vue&type=template&id=4b24d0bc&scoped=true"
import script from "./solutionMobile.vue?vue&type=script&lang=js"
export * from "./solutionMobile.vue?vue&type=script&lang=js"
import style0 from "./solutionMobile.vue?vue&type=style&index=0&id=4b24d0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24d0bc",
  null
  
)

export default component.exports